import React, {useEffect, useState} from 'react';
import { Provider } from 'react-redux';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import '../App.css';

// zippedi tools js imports
import { createHeimdalClient } from '@zippeditoolsjs/heimdal-client';
import {
  createHeimdalThunkExtra,
  heimdalReducers,
} from '@zippeditoolsjs/heimdal-react';
import { ReduxLoginWeb as PrivateRoute } from '@zippeditoolsjs/web';
import { lightTheme, darkTheme } from '@zippeditoolsjs/web';

import Welcome from './redux/containers/login/Welcome';
import Recover from './redux/containers/login/Recover';
import Profile from './redux/containers/profile/Profile';
import ProfileParser from './redux/containers/profile/ProfileParser';

// instantiate services and wire up dependencies
import createStore from 'core/store';
import HTTPService from 'core/services/http';
import DataSource from 'core/services/dataSource';
import TenantSource from 'core/services/tenantSource';
import { resolveLocalBackendUrl } from './components/utils/resolveLocalBackendUrl';

import { useTranslation, withTranslation } from 'react-i18next';

const { REACT_APP_BASE_URL, REACT_APP_AUTH_BACKEND_URL } = process.env;

// Bruno's Android build loads this app through the emulator's 10.0.2.2
// alias while iOS/browser use localhost — same build, different host the
// page is served from. authSource/tenantSource talk to a separately hosted
// backend (a different port on the same machine in local dev), so their
// configured host needs to track whichever local host actually served this
// page instead of the one baked in at `yarn start` time.
const resolvedAuthBackendUrl = resolveLocalBackendUrl(REACT_APP_AUTH_BACKEND_URL);

const http = new HTTPService();

const dataSource = new DataSource({
  baseUrl: REACT_APP_BASE_URL,
  http,
});

const authSource = createHeimdalClient({
  baseUrl: resolvedAuthBackendUrl,
});

// Same origin as authSource, but the tenant lookup runs before any session
// exists, so it is not part of the session client's surface.
const tenantSource = new TenantSource({
  baseUrl: resolvedAuthBackendUrl,
  http,
});

// heimdalReducers adds the `heimdalSession` branch PrivateRoute reads, and
// createHeimdalThunkExtra hands its thunks the client to read it with.
const store = createStore(
  { authSource, dataSource, tenantSource },
  {
    reducers: heimdalReducers,
    extraArgument: createHeimdalThunkExtra(authSource),
  },
);

const App = () => {
  const [theme, setTheme] = useState('light');
  const isDarkTheme = theme === 'dark';
  const toggleTheme = () => setTheme(isDarkTheme ? 'light' : 'dark');
  
  useEffect(() => {
    let languages = ['en', 'es', 'de', 'ja'];
    let userLanguage = navigator.language || navigator.userLanguage || 'en-US';
    userLanguage = userLanguage.split('-')[0];
    userLanguage = languages.includes(userLanguage) ? userLanguage : 'en';
  
    toogleTranslation(userLanguage);
  }, []);

  const { i18n } = useTranslation();
  const toogleTranslation = lang => i18n.changeLanguage(lang);

  return (
    <Provider store={store}>
      <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Welcome />} />
            <Route exact path="/int" element={<Welcome />} />
            <Route exact path="/ext" element={<Welcome />} />
            <Route exact path="/recover" element={<Recover />} />
            <Route exact path="/profile" element={<ProfileParser />} />
            <Route
              exact
              path="/profile/int"
              element={
                <PrivateRoute
                  tenattype="int"
                  appUrlLogin={REACT_APP_BASE_URL}
                  appBaseUrl={REACT_APP_BASE_URL + '/profile/int'}>
                  <Profile
                    isDarkTheme={isDarkTheme}
                    toggleTheme={toggleTheme}
                    toogleTranslation={toogleTranslation}
                  />
                </PrivateRoute>
              }
            />
            <Route
              exact
              path="/profile/ext"
              element={
                <PrivateRoute
                  tenattype="ext"
                  appUrlLogin={REACT_APP_BASE_URL}
                  appBaseUrl={REACT_APP_BASE_URL + '/profile/ext'}>
                  <Profile
                    isDarkTheme={isDarkTheme}
                    toggleTheme={toggleTheme}
                    toogleTranslation={toogleTranslation}
                  />
                </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};

export default withTranslation()(App);
